/**
 * Made for accessibility improvements - find button in the menu to focus it after closing the Creator modal.
 * NOTICE: this returns the first button in the menu with the given productTypeId,
 * but in the Menu one productTypeId could be used in multiple sections.
 */
export function findMenuItemButton(productTypeId) {
    var _a;
    // Try to find element of the product in the menu to focus it after closing the Creator modal
    return ((_a = document.querySelector(`[data-product="${productTypeId}"] button`)) !== null && _a !== void 0 ? _a : undefined);
}
